// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 15:59:34

export default {
  "id": "wonders-of-egypt-match",
  "slug": "wonders-of-egypt-match",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/019c146ddb844c83a2058f0d85138d64-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/019c146ddb844c83a2058f0d85138d64/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Wonders of Egypt Match",
      "description": "Begin a legendary journey in Wonders of Egypt Match, a thrilling Match 3 game set in Ancient Egypt! Join your guide, the Amara, as you match three or more gems and artifacts to uncover hidden treasures and secrets buried in pyramids, temples, and obelisks. With stunning visuals and immersive soundscapes, explore a world filled with ancient mysteries and challenges. Ready to prove your skills? Join the adventure and experience the wonders of Egypt today!",
      "instructions": "Match three or more identical symbols to clear them from the board. Each level has a specific goal, such as collecting certain symbols or removing obstacles. You have a limited number of moves, so strategise carefully! Use powerful boosters and the Amara’s wisdom to overcome tricky challenges. Watch out for unique obstacles inspired by Ancient Egypt. Match wisely, solve puzzles, and uncover the secrets hidden within the pyramids!",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "egypt",
        "match3"
      ]
    },
    "zh-CN": {
      "title": "埃及奇迹匹配",
      "description": "开始一段传奇之旅吧！在《埃及奇迹匹配》这款令人激动的匹配3游戏里，体验古埃及的魅力！跟随你的导游，阿玛拉，通过匹配三个或更多宝石和文物来揭开隐藏在金字塔、神庙和方尖碑中的宝藏和秘密。拥有惊人的视觉效果和沉浸式音效，探索一个充满古代谜团和挑战的世界。准备好证明你的技能了吗？加入这场冒险，今天体验埃及的奇迹！",
      "instructions": "匹配三个或更多相同的符号，从棋盘上清除它们。每个关卡都有特定的目标，例如收集特定符号或移除障碍。你的移动次数有限，所以请谨慎策略！使用强大的增强器和Amara的智慧来克服棘手的挑战。注意由古埃及启发的独特障碍。明智地匹配，解决谜题，揭示金字塔隐藏的秘密！",
      "genres": [
        "三消匹配"
      ],
      "tags": [
        "埃及",
        "三消游戏"
      ]
    },
    "zh-TW": {
      "title": "埃及奇觀配對",
      "description": "開啟一場傳奇的冒險旅程，在《埃及奇蹟》配對遊戲中，一場令人興奮的配對3遊戲，設置在古埃及！與您的導遊，阿瑪拉一起，匹配三個或以上的寶石和文物，揭露藏在金字塔、神殿和方尖碑中的隱藏財寶和秘密。搭配令人驚艷的視覺和沉浸式聲景，探索充滿古老謎團和挑戰的世界。準備好展現您的技巧了嗎？加入冒險，體驗埃及的奇蹟吧！",
      "instructions": "匹配三個或更多相同的符號，從棋盤上清除它們。每個關卡都有特定的目標，例如收集特定符號或移除障礙物。你有限定的移動次數，所以要謹慎策略！使用強大的加成器和Amara的智慧來克服困難挑戰。小心那些受古埃及啟發的獨特障礙物。明智地匹配，解謎，並發現金字塔中隱藏的秘密！",
      "genres": [
        "配對3"
      ],
      "tags": [
        "埃及",
        "三消匹配"
      ]
    },
    "zh-HK": {
      "title": "埃及奇蹟配對",
      "description": "開啟一場傳說之旅，進入《埃及奇蹟》配對遊戲，一場設於古埃及的刺激配對3遊戲！隨著你的導遊，阿瑪拉，配對三顆或以上寶石和遺物，揭開埋藏在金字塔、神廟和方尖碑中的隱藏寶藏和秘密。伴隨著驚艷的視覺效果和沉浸式音效場景，探索充滿古謎和挑戰的世界。準備好展現你的技巧了嗎？加入這場冒險，體驗埃及的奇蹟吧！",
      "instructions": "匹配三個或以上的相同符號以清除它們從遊戲板。每個關卡都有特定的目標，例如收集特定符號或移除障礙物。你擁有有限次數的移動，所以要謹慎策劃！使用強力加成器和Amara的智慧來克服困難挑戰。留意受古埃及啟發的獨特障礙物。明智配對，解開謎題，發現隱藏在金字塔中的秘密！",
      "genres": [
        "匹配3"
      ],
      "tags": [
        "埃及",
        "匹配3"
      ]
    },
    "ja": {
      "title": "エジプトの驚異マッチ",
      "description": "エジプトの神秘に満ちた世界を探検する壮大な旅を始めましょう、古代エジプトを舞台にしたスリリングなマッチ3ゲーム、ワンダーズ・オブ・エジプトマッチで！ガイドのアマラと共に、三つ以上の宝石や遺物をマッチさせることで、ピラミッド、神殿、obelisksに埋もれた隠された宝物や秘密を解き明かしましょう。圧巻の視覚と没入感のあるサウンドスケープで、古代の謎と挑戦に満ちた世界を探検してください。あなたのスキルを証明する準備はできましたか？冒険に参加し、エジプトの驚異を体験しましょう！",
      "instructions": "同じシンボルを3つ以上一致させてボードから消去します。各レベルには特定の目標があり、シンボルを収集したり、障害物を取り除いたりするものがあります。動きの数に制限があるので、慎重に戦略を立ててください！強力なブースターとアマラの知恵を使って困難な挑戦に挑みましょう。古代エジプトにインスパイアされたユニークな障害物に注意してください。賢く一致させ、パズルを解き、ピラミッドに隠された秘密を解き明かしましょう！",
      "genres": [
        "マッチ3"
      ],
      "tags": [
        "エジプト",
        "マッチ3"
      ]
    },
    "ko": {
      "title": "에ジ프트의 기적 매치",
      "description": "에gypt의 기적에서 시작하는 전설적인 여정을 떠나세요! 고대 이집트를 배경으로 한 흥미진진한 매치 3 게임입니다! 가이드 아마라와 함께 세 개 이상의 보석과 유물을 매칭하여 피라미드, 신전, obelisks에 묻혀 있는 숨겨진 보물과 비밀을 밝혀보세요. 장관한 시각적 효과와 몰입감 있는 사운드스케이프로 고대의 미스터리와 도전을 탐험하세요. 자신의 실력을 증명할 준비가 되셨나요? 이 모험에 함께해 이집트의 기적을 경험해보세요!",
      "instructions": "동일한 기호 3개 이상을 맞추어 보드에서 제거하세요. 각 레벨은 특정 기호 수집이나 장애물 제거와 같은 특정 목표를 가집니다. 이동 횟수는 제한되어 있으므로 신중하게 전략을 세우세요! 강력한 보스터와 아마라의 지혜를 사용하여 어려운 도전을 극복하세요. 고대 이집트를 영감으로 얻은 독특한 장애물에 주의하세요. 지혜롭게 맞추고 퍼즐을 해결하여 피라미드 안에 숨겨진 비밀을 밝혀보세요!",
      "genres": [
        "매치3"
      ],
      "tags": [
        "에ジ프트",
        "매치3"
      ]
    },
    "fr": {
      "title": "Merveilles de l'Égypte Match",
      "description": "Commencez un voyage légendaire dans Wonders of Egypt Match, un jeu passionnant de Match 3 se déroulant dans l'Égypte antique ! Rejoignez votre guide, l'Amara, et alignez trois ou plus de gemmes et d'artéfacts pour découvrir des trésors et des secrets enfouis dans des pyramides, des temples et des obélisques. Avec des visuels époustouflants et des ambiances sonores immersives, explorez un monde rempli de mystères et de défis anciens. Prêt à prouver vos compétences ? Rejoignez l'aventure et découvrez les merveilles de l'Égypte aujourd'hui !",
      "instructions": "Faites correspondre trois ou plus de symboles identiques pour les supprimer du plateau. Chaque niveau a un objectif spécifique, comme collecter certains symboles ou éliminer des obstacles. Vous avez un nombre limité de mouvements, donc stratégisez bien ! Utilisez des boosters puissants et la sagesse d'Amara pour surmonter des défis délicats. Attention aux obstacles uniques inspirés de l'Égypte antique. Jouez intelligemment, résolvez des puzzles et découvrez les secrets enfouis dans les pyramides !",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "Égypte",
        "Match3"
      ]
    }
  }
};
